/* Which brand's admin console a client belongs to.

   The user's `brand` field only records where they SIGNED UP — most legacy users
   have no brand at all, and a client can register on one brand yet buy the other's
   services. So the ACCOUNTING (corporate) admin must see everyone with a real
   accounting footprint (a business-setup order, accounting activated, or a purchased
   accounting package), not only brand-tagged signups. This mirrors what the corporate
   Dashboard (AdminAccounting) already does, so the Command Center / Analytics stop
   hiding clients the Dashboard shows. */

export function hasAccountingFootprint(u: any): boolean {
  return !!(u && (
    (u.businessSetupData && typeof u.businessSetupData === 'object' && Object.keys(u.businessSetupData).length > 0) ||
    u.accountingActivated ||
    (Array.isArray(u.purchasedPackages) && u.purchasedPackages.length > 0) ||
    (u.purchasedPackage && u.purchasedPackage.name)
  ));
}

/** True if this client belongs in the given brand's admin console. */
export function belongsToBrand(u: any, isCorp: boolean): boolean {
  if (isCorp) return u.brand !== 'consulting' && (u.brand === 'corporate' || hasAccountingFootprint(u));
  // Consulting admin: consulting-tagged + untagged legacy (unchanged behaviour).
  return u.brand === 'consulting' || !u.brand;
}
